import {useCurrentRepository} from '@github-ui/current-repository'
import {ChecksStatusBadge, useCommitChecksStatusDetails} from '@github-ui/commit-checks-status'

interface Props {
  oid: string
  status: string | undefined
  descriptionString?: string
  badgeProps?: Omit<
    React.ComponentProps<typeof ChecksStatusBadge>,
    'statusRollup' | 'combinedStatus' | 'onWillOpenPopup' | 'disablePopover'
  >
}

export function AsyncChecksStatusBadge({status, oid, badgeProps = {}, descriptionString = ''}: Props) {
  const repo = useCurrentRepository()
  const [details, fetchDetails] = useCommitChecksStatusDetails(oid, repo)

  return status ? (
    <ChecksStatusBadge
      disablePopover={false}
      size={'small'}
      statusRollup={status}
      buttonSx={{height: '18px', color: 'fg.muted', p: 0}}
      combinedStatus={details}
      descriptionText={descriptionString}
      onWillOpenPopup={fetchDetails}
      {...badgeProps}
    />
  ) : null
}

try{ AsyncChecksStatusBadge.displayName ||= 'AsyncChecksStatusBadge' } catch {}